import { render, staticRenderFns } from "./activity-list.vue?vue&type=template&id=f2ecde66&scoped=true"
import script from "./activity-list.vue?vue&type=script&lang=js"
export * from "./activity-list.vue?vue&type=script&lang=js"
import style0 from "./activity-list.vue?vue&type=style&index=0&id=f2ecde66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ecde66",
  null
  
)

export default component.exports